export default {
  install: function(Vue, opt) {
    Vue.prototype.myfn = function(obj, val) {
    
    },
      Vue.prototype.open_tips = function(obj, title, msg, type, fn) {
        if (type) {
          obj.$notify({
            title: title,
            message: msg,
            type: 'success',
            duration: 1000,
            onClose: fn,
          })
        } else {
          obj.$notify.error({
            title: title,
            message: msg,
            duration: 1000,
            onClose: fn,
          })
        }
      },
      Vue.prototype.open_firm = function(obj, title, msg, fn) {
        obj.$confirm(msg, title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          callback: fn,
        })
      },
      
      Vue.prototype.to_login = function(obj, route_query) {
        if (obj.$router) {
          obj.$router.push({
            path: '/login',
            name: 'login',
            params: route_query,
            // query: {
            //
            // }
          })
        } else {
          obj.$route.push({
            path: '/login',
            name: 'login',
            params: route_query,
            // query: {
            //
            // }
          })
        }
        
      },
      Vue.prototype.data_int = function(obj, val) {
        let value = Math.floor(val)
        return value
      },
      Vue.prototype.data_to_int = function(obj, val) {
        return parseInt(val)
      },
      Vue.prototype.data_ps = function(obj, data1, data2, fn) {
        let data = data1.push(data2)
        return data
      },
      Vue.prototype.data_con = function(obj, data1, data2, fn) {
        let data = data1.concat(data2)
        return data
      }
  },
}



//////////////////
// WEBPACK FOOTER
// ./common/common.js
// module id = 2UA+
// module chunks = 1